import * as types from '../mutations-types'
import Constants from "../../js/constants";
import db from '../../js/db'

function isValidLayout(layout) {
  return Object.values(Constants.LAYOUT).indexOf(layout) !== -1;
}

function getDefaultLayout() {
  const width = typeof window !== "undefined" ? window.innerWidth : 0;
  return width >= Constants.LAYOUT_BREAKPOINT.PANORAMICA_MIN
    ? Constants.LAYOUT.PANORAMICA
    : Constants.LAYOUT.MAIN;
}

function getStoredLayout() {
  const storedLayout = localStorage.getItem(Constants.LS_CURRENT_LAYOUT);
  return isValidLayout(storedLayout) ? storedLayout : getDefaultLayout();
}

const state = {
  selected_tab: 1,
  is_mobile: true,
  useSound: 1,
  tavoloLayout: null,
  tavoloSize: Constants.TAVOLO_SIZE.SMALL,
  squadreSize: null,
  version: null,
  annoStats: null,
  homeAway: null,
  currentLayout: getStoredLayout(),
}

function getDefaultSquadreSize(state, rootGetters) {
  if (state.squadreSize != null) {
    return state.squadreSize
  } else {
    let nSquadre = rootGetters.asta_squadre_array.length
    if (nSquadre <= 6) {
      return Constants.SQUADRE_SIZE.MEDIUM
    } else {
      return Constants.SQUADRE_SIZE.SMALL
    }
  }
}

function getDefaultTavoloLayout(state, rootGetters) {
  if (state.tavoloLayout != null) {
    return state.tavoloLayout
  } else {
    let nSquadre = rootGetters.asta_squadre_array.length
    if (nSquadre <= 10) {
      return Constants.TAVOLO_LAYOUT.CERCHIO
    } else {
      return Constants.TAVOLO_LAYOUT.GRIGLIA
    }
  }
}

// getters
const getters = {
  selected_tab: state => state.selected_tab,
  is_mobile: state => state.is_mobile,
  useSound: state => state.useSound,
  tavoloLayout: (state, getters, rootState, rootGetters) => getDefaultTavoloLayout(state, rootGetters),
  tavoloSize: state => state.tavoloSize,
  version: state => state.version,
  annoStats: state => state.annoStats,
  currentLayout: state => state.currentLayout || Constants.LAYOUT.MAIN,
  isLayoutPanoramica: state => state.currentLayout === Constants.LAYOUT.PANORAMICA,
  homeAway: state => state.homeAway || localStorage.getItem(Constants.LS_HOME_AWAY) || 'homeAway',
  squadreSize: (state, getters, rootState, rootGetters) => getDefaultSquadreSize(state, rootGetters)
}

// actions
const actions = {
  selectTab({
    commit,
    state
  }, idx) {
    commit(types.PREFS_UPD, {
      selected_tab: idx
    })
  },
  setMobile({
    commit,
    state
  }, mobile) {
    if (mobile && state.currentLayout === Constants.LAYOUT.PANORAMICA) {
      commit(types.PREFS_UPD, {
        currentLayout: Constants.LAYOUT.MAIN
      })
    } else if (!mobile) {
      commit(types.PREFS_UPD, {
        currentLayout: getStoredLayout()
      })
    }

    commit(types.PREFS_UPD, {
      is_mobile: mobile
    })
  },
  setDefaultLayout({
    commit
  }, layout) {
    const storedLayout = localStorage.getItem(Constants.LS_CURRENT_LAYOUT);
    if (!isValidLayout(storedLayout) && isValidLayout(layout)) {
      commit(types.PREFS_UPD, {
        currentLayout: layout
      })
    }
  },
  switchLayout({
    commit,
    state
  }, val) {
    if (val === Constants.LAYOUT.PANORAMICA && state.is_mobile) {
      db.emit("showPanoramicaMobileInfo");
      return;
    }

    localStorage.setItem(Constants.LS_CURRENT_LAYOUT, val);
    commit(types.PREFS_UPD, {
      currentLayout: val
    })
  },
  setUseSound({
    commit,
    state
  }, onOrOff) {
    commit(types.PREFS_UPD, {
      useSound: onOrOff
    })
  },
  setTavoloLayout({
    commit,
    state
  }, layout) {
    commit(types.PREFS_UPD, {
      tavoloLayout: layout
    })
  },
  setTavoloSize({
    commit,
    state
  }, size) {
    commit(types.PREFS_UPD, {
      tavoloSize: size
    })
  },
  setSquadreSize({
    commit,
    state
  }, size) {
    commit(types.PREFS_UPD, {
      squadreSize: size
    })
  },
  setAnnoStats({
    commit,
    state
  }, value) {
    commit(types.PREFS_UPD, {
      annoStats: value
    })
  },
  setHomeAway({
    commit,
    state
  }, value) {
    commit(types.PREFS_UPD, {
      homeAway: value
    })
  },
  setVersion({
    commit
  }) {
    return db.getVersion()
      .then(
        (version) => {
          commit(types.PREFS_UPD, {
            version: version
          })
        }
      )
  },

  // setVersion({
  //   commit,
  //   state
  // }, version) {
  //   commit(types.PREFS_UPD, {
  //     version: version
  //   })
  // },
}

// mutations
const mutations = {
  [types.PREFS_UPD](state, values) {
    for (let k in values) {
      state[k] = values[k];
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
